import type { TextFieldProps } from "@mui/material";
import clsx from "clsx";
import { EmailFieldContacts } from "./contacts";
import { useEmailField } from "./logics";
import { TextFieldStyled, classes } from "./styles";

export interface IEmailField extends Omit<TextFieldProps, "value" | "onChange" | "select" | "SelectProps"> {
  value?: string[];
  onChange?: (value: string[]) => void;
  limitTags?: number;
}

export const EmailField = ({ value, onChange, limitTags = 3, ...props }: IEmailField) => {
  const { text, setText, focus, contacts, handleDelete, handleKeyDown, handleFocus, handleBlur } = useEmailField(
    value,
    onChange
  );

  return (
    <TextFieldStyled
      {...props}
      limitTags={limitTags}
      focus={focus}
      value={text}
      onChange={(evt) => setText(evt.target.value)}
      className={clsx(classes.root, props.className)}
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <EmailFieldContacts contacts={contacts} limitTags={limitTags} size={props.size} onDelete={handleDelete} />
        ),
      }}
      inputProps={{
        ...props.inputProps,
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        onBlur: handleBlur,
      }}
    />
  );
};
